/**
 * Definiciones de sistemas estelares para el mapa.
 * Basado en las imágenes de contextos/evolución_sistemas (MRG-A_AÑO_Nombre.png).
 * Cada sistema: id, name, sublabel?, type, bodies[]
 * Varios planetas por sistema para reflejar el mapa galáctico (múltiples órbitas).
 */
const planetColors = ['#708090', '#5F9EA0', '#8B7355', '#6B8E23', '#CD5C5C', '#2E8B57', '#87CEEB'];
const defaultBodies = (name) => [
    { type: 'planet', name: `${name} I`, color: planetColors[0] },
    { type: 'planet', name: `${name} II`, color: planetColors[1] },
    { type: 'planet', name: `${name} III`, color: planetColors[2] },
    { type: 'planet', name: `${name} IV`, color: planetColors[3] },
    { type: 'planet', name: `${name} V`, color: planetColors[4] },
    { type: 'belt', name: 'Anillo' }
];

export const SISTEMAS = {
    sol: {
        id: 'sol',
        name: 'Sistema Sol',
        sublabel: 'Mundo natal',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Mercury', color: '#8B7355' },
            { type: 'planet', name: 'Venus', color: '#E6C229' },
            { type: 'planet', name: 'Earth', color: '#4169E1' },
            { type: 'planet', name: 'Mars', color: '#CD5C5C' },
            { type: 'planet', name: 'Jupiter', color: '#DAA520' },
            { type: 'planet', name: 'Saturn', color: '#DEB887' },
            { type: 'planet', name: 'Uranus', color: '#87CEEB' },
            { type: 'planet', name: 'Neptune', color: '#4169E1' },
            { type: 'belt', name: 'Kuiper Belt' }
        ]
    },
    croshaw: {
        id: 'croshaw',
        name: 'Sistema Croshaw',
        sublabel: '2271',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Croshaw I', color: '#708090' },
            { type: 'planet', name: 'Angels', color: '#5F9EA0' },
            { type: 'planet', name: 'Vann', color: '#8B7355' },
            { type: 'planet', name: 'Croshaw IV', color: '#6B8E23' },
            { type: 'planet', name: 'Daedalus', color: '#CD5C5C' },
            { type: 'planet', name: 'Icarus', color: '#2E8B57' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    rethor: {
        id: 'rethor',
        name: 'Sistema Rethor',
        sublabel: '2287',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Rethor I', color: '#708090' },
            { type: 'planet', name: 'Persee', color: '#5F9EA0' },
            { type: 'planet', name: 'Reisse', color: '#8B7355' },
            { type: 'planet', name: 'Mentor', color: '#CD5C5C' },
            { type: 'planet', name: 'Rethor V', color: '#6B8E23' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    null: {
        id: 'null',
        name: 'Sistema Null',
        sublabel: '2290',
        type: 'unclaimed',
        bodies: [
            { type: 'planet', name: 'Nul I', color: '#708090' },
            { type: 'planet', name: 'Nul II', color: '#5F9EA0' },
            { type: 'planet', name: 'Nul III', color: '#8B7355' },
            { type: 'planet', name: 'Cole I', color: '#CD5C5C' },
            { type: 'planet', name: 'Ashama', color: '#6B8E23' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    fora: { id: 'fora', name: 'Sistema Fora', sublabel: '2307', type: 'uee', bodies: defaultBodies('Fora') },
    banshee: { id: 'banshee', name: 'Sistema Banshee', sublabel: '2317', type: 'uee', bodies: defaultBodies('Banshee') },
    caliban: { id: 'caliban', name: 'Sistema Caliban', sublabel: '2341', type: 'uee', bodies: defaultBodies('Caliban') },
    oberon: { id: 'oberon', name: 'Sistema Oberon', sublabel: '2356', type: 'unclaimed', bodies: defaultBodies('Oberon') },
    nemo: {
        id: 'nemo',
        name: 'Sistema Nemo',
        sublabel: '2362 (of. 2364)',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Nemo I', color: '#708090' },
            { type: 'planet', name: 'Nemo II', color: '#5F9EA0' },
            { type: 'planet', name: 'Ergo', color: '#8B7355' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    centauri: {
        id: 'centauri',
        name: 'Sistema Centauri',
        sublabel: '2365',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Centauri I', color: '#708090' },
            { type: 'planet', name: 'Van', color: '#5F9EA0' },
            { type: 'planet', name: 'Saizes', color: '#8B7355' },
            { type: 'planet', name: 'Cent IV', color: '#CD5C5C' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    vega: {
        id: 'vega',
        name: 'Sistema Vega',
        sublabel: '2402',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Vega I', color: '#708090' },
            { type: 'planet', name: 'Aren', color: '#5F9EA0' },
            { type: 'planet', name: 'Selene', color: '#87CEEB' },
            { type: 'planet', name: 'Vega IV', color: '#CD5C5C' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    vector: { id: 'vector', name: 'Sistema Vector', sublabel: '—', type: 'vanduul', bodies: defaultBodies('Vector') },
    virgil: { id: 'virgil', name: 'Sistema Virgil', sublabel: '2412', type: 'vanduul', bodies: defaultBodies('Virgil') },
    vermillion: { id: 'vermillion', name: 'Sistema Vermillion', sublabel: '—', type: 'vanduul', bodies: defaultBodies('Vermillion') },
    virgo: { id: 'virgo', name: 'Sistema Virgo', sublabel: '—', type: 'vanduul', bodies: defaultBodies('Virgo') },
    vulture: { id: 'vulture', name: 'Sistema Vulture', sublabel: '—', type: 'vanduul', bodies: defaultBodies('Vulture') },
    vagabond: { id: 'vagabond', name: 'Sistema Vagabond', sublabel: '—', type: 'vanduul', bodies: defaultBodies('Vagabond') },
    vesper: { id: 'vesper', name: 'Sistema Vesper', sublabel: '—', type: 'vanduul', bodies: defaultBodies('Vesper') },
    vendetta: { id: 'vendetta', name: 'Sistema Vendetta', sublabel: '—', type: 'vanduul', bodies: defaultBodies('Vendetta') },
    davien: {
        id: 'davien',
        name: 'Sistema Davien',
        sublabel: '2430',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Davien I', color: '#708090' },
            { type: 'planet', name: 'Cestulus', color: '#5F9EA0' },
            { type: 'planet', name: 'Davien III', color: '#8B7355' },
            { type: 'planet', name: 'Davien IV', color: '#CD5C5C' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    yulin: { id: 'yulin', name: 'Sistema Yulin', sublabel: '2430', type: 'uee', bodies: defaultBodies('Yulin') },
    cathcart: { id: 'cathcart', name: 'Sistema Cathcart', sublabel: '2438', type: 'unclaimed', bodies: defaultBodies('Cathcart') },
    bacchus: { id: 'bacchus', name: 'Sistema Bacchus', sublabel: '2439', type: 'banu', bodies: defaultBodies('Bacchus') },
    bremen: {
        id: 'bremen',
        name: 'Sistema Bremen',
        sublabel: '2441',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Bremen I', color: '#708090' },
            { type: 'planet', name: 'Bremen II', color: '#5F9EA0' },
            { type: 'planet', name: 'Bremen III', color: '#8B7355' },
            { type: 'planet', name: 'Ryttir', color: '#CD5C5C' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    nexus: { id: 'nexus', name: 'Sistema Nexus', sublabel: '2445', type: 'uee', bodies: defaultBodies('Nexus') },
    corel: { id: 'corel', name: 'Sistema Corel', sublabel: '2449', type: 'uee', bodies: defaultBodies('Corel') },
    geddon: { id: 'geddon', name: 'Sistema Geddon', sublabel: '2450', type: 'banu', bodies: defaultBodies('Geddon') },
    ferron: { id: 'ferron', name: 'Sistema Ferron', sublabel: '2460', type: 'uee', bodies: defaultBodies('Ferron') },
    kilian: { id: 'kilian', name: 'Sistema Kilian', sublabel: '2463', type: 'uee', bodies: defaultBodies('Kilian') },
    cano: { id: 'cano', name: 'Sistema Cano', sublabel: '2463', type: 'uee', bodies: defaultBodies('Cano') },
    ellis: {
        id: 'ellis',
        name: 'Sistema Ellis',
        sublabel: '2467',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Ellis I', color: '#708090' },
            { type: 'planet', name: 'Ellis II', color: '#5F9EA0' },
            { type: 'planet', name: 'Ellis III', color: '#8B7355' },
            { type: 'planet', name: 'Ellis IV', color: '#CD5C5C' },
            { type: 'planet', name: 'Ellis V', color: '#6B8E23' },
            { type: 'planet', name: 'Ellis VI', color: '#2E8B57' },
            { type: 'planet', name: 'Ellis VII', color: '#87CEEB' },
            { type: 'planet', name: 'Green', color: '#228B22' },
            { type: 'planet', name: 'Kampoi', color: '#DAA520' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    pyro: {
        id: 'pyro',
        name: 'Sistema Pyro',
        sublabel: '2469',
        type: 'unclaimed',
        bodies: [
            { type: 'planet', name: 'Pyro I', color: '#708090' },
            { type: 'planet', name: 'Monox', color: '#5F9EA0' },
            { type: 'planet', name: 'Bloom', color: '#8B7355' },
            { type: 'planet', name: 'Pyro IV', color: '#6B8E23' },
            { type: 'planet', name: 'Pyro V', color: '#CD5C5C' },
            { type: 'moon', name: 'Ignis', color: '#708090' },
            { type: 'moon', name: 'Fairo', color: '#5F9EA0' },
            { type: 'moon', name: 'Adir', color: '#8B7355' },
            { type: 'moon', name: 'Vatra', color: '#6B8E23' },
            { type: 'moon', name: 'Fuego', color: '#CD5C5C' },
            { type: 'moon', name: 'Vuur', color: '#2E8B57' },
            { type: 'moon', name: 'Pyro IV', color: '#87CEEB' },
            { type: 'planet', name: 'Terminus', color: '#2E8B57' }
        ]
    },
    min: { id: 'min', name: 'Sistema Min', sublabel: '2473', type: 'unclaimed', bodies: defaultBodies('Min') },
    tanga: { id: 'tanga', name: 'Sistema Tanga', sublabel: '2473', type: 'unclaimed', bodies: defaultBodies('Tanga') },
    tiber: { id: 'tiber', name: 'Sistema Tiber', sublabel: '2474', type: 'vanduul', bodies: defaultBodies('Tiber') },
    taranis: {
        id: 'taranis',
        name: 'Sistema Taranis',
        sublabel: '2478',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Taranis I', color: '#708090' },
            { type: 'planet', name: 'Taranis II', color: '#5F9EA0' },
            { type: 'planet', name: 'Taranis III', color: '#8B7355' },
            { type: 'planet', name: 'Taranis IV', color: '#CD5C5C' },
            { type: 'belt', name: 'Alpha Belt' },
            { type: 'belt', name: 'Beta Belt' }
        ]
    },
    oretani: { id: 'oretani', name: 'Sistema Oretani', sublabel: '2481', type: 'uee', bodies: defaultBodies('Oretani') },
    idris: { id: 'idris', name: 'Sistema Idris', sublabel: '2493', type: 'uee', bodies: defaultBodies('Idris') },
    magnus: { id: 'magnus', name: 'Sistema Magnus', sublabel: '2499', type: 'uee', bodies: defaultBodies('Magnus') },
    terra: { id: 'terra', name: 'Sistema Terra', sublabel: '2508', type: 'uee', bodies: defaultBodies('Terra') },
    hadrian: { id: 'hadrian', name: 'Sistema Hadrian', sublabel: '2510', type: 'uee', bodies: defaultBodies('Hadrian') },
    kins: { id: 'kins', name: 'Sistema Kins', sublabel: '2510', type: 'uee', bodies: defaultBodies('Kins') },
    kiel: {
        id: 'kiel',
        name: 'Sistema Kiel',
        sublabel: '2514',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Kiel I', color: '#708090' },
            { type: 'planet', name: 'Kiel II', color: '#5F9EA0' },
            { type: 'planet', name: 'Kiel III', color: '#8B7355' },
            { type: 'planet', name: 'Kiel IV', color: '#CD5C5C' },
            { type: 'planet', name: 'Kiel V', color: '#6B8E23' },
            { type: 'planet', name: 'Kiel VI', color: '#2E8B57' },
            { type: 'planet', name: 'Severus', color: '#87CEEB' },
            { type: 'belt', name: 'Alpha Belt' }
        ]
    },
    hades: {
        id: 'hades',
        name: 'Sistema Hades',
        sublabel: '2515',
        type: 'unclaimed',
        bodies: [
            { type: 'planet', name: 'Hades I', color: '#708090' },
            { type: 'planet', name: 'Hades II', color: '#5F9EA0' },
            { type: 'planet', name: 'Hades III', color: '#8B7355' },
            { type: 'planet', name: 'Hades IV', color: '#CD5C5C' },
            { type: 'planet', name: 'Hades V', color: '#87CEEB' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    kyukya: { id: 'kyukya', name: 'Sistema Kyuk\'ya', sublabel: '2515', type: 'xian', bodies: defaultBodies('Kyukya') },
    indra: { id: 'indra', name: 'Sistema Indra', sublabel: '2515', type: 'xian', bodies: defaultBodies('Indra') },
    baker: {
        id: 'baker',
        name: 'Sistema Baker',
        sublabel: '2522',
        type: 'xian',
        bodies: [
            { type: 'planet', name: 'Baker I', color: '#708090' },
            { type: 'planet', name: 'Baker II', color: '#5F9EA0' },
            { type: 'planet', name: 'Baker III', color: '#8B7355' },
            { type: 'planet', name: 'Baker IV', color: '#CD5C5C' },
            { type: 'planet', name: 'Baker V', color: '#6B8E23' },
            { type: 'planet', name: 'Baker VI', color: '#2E8B57' },
            { type: 'planet', name: 'Baker VII', color: '#87CEEB' },
            { type: 'planet', name: 'CSO Kenia', color: '#DAA520' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    tayac: {
        id: 'tayac',
        name: 'Sistema Tayac',
        sublabel: '2524',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Tayac I', color: '#708090' },
            { type: 'planet', name: 'Tayac II', color: '#5F9EA0' },
            { type: 'planet', name: 'Tayac III', color: '#8B7355' },
            { type: 'belt', name: 'Tayac Belt' }
        ]
    },
    horus: {
        id: 'horus',
        name: 'Sistema Horus',
        sublabel: '2528',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Sterling', color: '#708090' },
            { type: 'planet', name: 'Horus I', color: '#5F9EA0' },
            { type: 'planet', name: 'Horus II', color: '#8B7355' },
            { type: 'planet', name: 'Horus III', color: '#CD5C5C' },
            { type: 'planet', name: 'Horus IV', color: '#6B8E23' },
            { type: 'belt', name: 'Alpha Belt' },
            { type: 'belt', name: 'Beta Belt' }
        ]
    },
    helios: {
        id: 'helios',
        name: 'Sistema Helios',
        sublabel: '2529',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Helios I', color: '#708090' },
            { type: 'planet', name: 'Helios II', color: '#5F9EA0' },
            { type: 'planet', name: 'Helios III', color: '#8B7355' },
            { type: 'planet', name: 'Helios IV', color: '#CD5C5C' },
            { type: 'planet', name: 'Helios V', color: '#6B8E23' },
            { type: 'planet', name: 'Targarda I', color: '#87CEEB' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    rilah: { id: 'rilah', name: 'Sistema Rilah', sublabel: '2530', type: 'uee', bodies: defaultBodies('Rilah') },
    kaya: { id: 'kaya', name: 'Sistema Kaya', sublabel: '—', type: 'uee', bodies: defaultBodies('Kaya') },
    elsin: { id: 'elsin', name: "Sistema El'sin", sublabel: '—', type: 'xian', bodies: defaultBodies('El\'sin') },
    khabari: { id: 'khabari', name: 'Sistema Khabari', sublabel: '—', type: 'xian', bodies: defaultBodies('Khabari') },
    markahil: { id: 'markahil', name: 'Sistema Markahil', sublabel: '—', type: 'xian', bodies: defaultBodies('Markahil') },
    eealus: { id: 'eealus', name: 'Sistema Eaalus', sublabel: '2602', type: 'uee', bodies: defaultBodies('Eaalus') },
    hadur: { id: 'hadur', name: 'Sistema Hadur', sublabel: '2531', type: 'xian', bodies: defaultBodies('Hadur') },
    yamon: { id: 'yamon', name: 'Sistema Yā\'mon', sublabel: '2529', type: 'xian', bodies: defaultBodies('Yamon') },
    odin: { id: 'odin', name: 'Sistema Odin', sublabel: '2532', type: 'uee', bodies: defaultBodies('Odin') },
    charon: {
        id: 'charon',
        name: 'Sistema Charon',
        sublabel: '2538',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Charon I', color: '#708090' },
            { type: 'planet', name: 'Charon II', color: '#5F9EA0' },
            { type: 'planet', name: 'Charon III', color: '#8B7355' },
            { type: 'planet', name: 'Charon IV', color: '#CD5C5C' },
            { type: 'planet', name: 'Charon V', color: '#6B8E23' },
            { type: 'planet', name: 'Broken Moon', color: '#87CEEB' },
            { type: 'belt', name: 'Alpha Belt' }
        ]
    },
    gurzil: {
        id: 'gurzil',
        name: 'Sistema Gurzil',
        sublabel: '2539',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Gurzil I', color: '#708090' },
            { type: 'planet', name: 'Gurzil II', color: '#5F9EA0' },
            { type: 'planet', name: 'Gurzil III', color: '#8B7355' },
            { type: 'planet', name: 'Gurzil IV', color: '#CD5C5C' },
            { type: 'planet', name: 'Gurzil V', color: '#6B8E23' },
            { type: 'planet', name: 'Gurzil VI', color: '#2E8B57' },
            { type: 'planet', name: 'Yogi', color: '#87CEEB' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    elysium: {
        id: 'elysium',
        name: 'Sistema Elysium',
        sublabel: '2541',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Idris I', color: '#708090' },
            { type: 'planet', name: 'Idris II', color: '#5F9EA0' },
            { type: 'planet', name: 'Idris III', color: '#8B7355' },
            { type: 'planet', name: 'Locke', color: '#CD5C5C' },
            { type: 'planet', name: 'Idris V', color: '#6B8E23' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    castra: {
        id: 'castra',
        name: 'Sistema Castra',
        sublabel: '2544',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Castra I', color: '#708090' },
            { type: 'planet', name: 'Cascom', color: '#5F9EA0' }
        ]
    },
    goss: {
        id: 'goss',
        name: 'Sistema Goss',
        sublabel: '2563',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Goss I', color: '#708090' },
            { type: 'planet', name: 'Goss II', color: '#5F9EA0' },
            { type: 'planet', name: 'Cassel', color: '#8B7355' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    oya: {
        id: 'oya',
        name: 'Sistema Oya',
        sublabel: '2566',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Oya I', color: '#708090' },
            { type: 'planet', name: 'Oya II', color: '#5F9EA0' },
            { type: 'planet', name: 'Oya III', color: '#8B7355' },
            { type: 'planet', name: 'Oya IV', color: '#CD5C5C' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    nyx: {
        id: 'nyx',
        name: 'Sistema Nyx',
        sublabel: '2582',
        type: 'unclaimed',
        bodies: [
            { type: 'planet', name: 'Nyx I', color: '#708090' },
            { type: 'planet', name: 'Nyx II', color: '#5F9EA0' },
            { type: 'planet', name: 'Nyx III', color: '#8B7355' },
            { type: 'belt', name: 'Glaciem Ring' },
            { type: 'belt', name: 'Keeger Belt' }
        ]
    },
    thusung: { id: 'thusung', name: 'Sistema Th.us\'ūng', sublabel: '2583', type: 'xian', bodies: defaultBodies('Thusung') },
    pallas: { id: 'pallas', name: 'Sistema Pallas', sublabel: '2583', type: 'xian', bodies: defaultBodies('Pallas') },
    eelaut: { id: 'eelaut', name: 'Sistema Eelaut', sublabel: '2602', type: 'xian', bodies: defaultBodies('Eelaut') },
    ealuth: { id: 'ealuth', name: 'Sistema Ē\'aluth', sublabel: '2602', type: 'xian', bodies: defaultBodies('Ealuth') },
    kayfa: { id: 'kayfa', name: 'Sistema Kayfa', sublabel: '2617', type: 'xian', bodies: defaultBodies('Kayfa') },
    kaipua: { id: 'kaipua', name: 'Sistema Kai\'pua', sublabel: '2617', type: 'xian', bodies: defaultBodies('Kaipua') },
    ayrka: { id: 'ayrka', name: 'Sistema Ayr\'ka', sublabel: '2650', type: 'xian', bodies: defaultBodies('Ayrka') },
    alika: { id: 'alika', name: 'Sistema Ail\'ka', sublabel: '2650', type: 'xian', bodies: defaultBodies('Alika') },
    orion: { id: 'orion', name: 'Sistema Orion', sublabel: '2650', type: 'vanduul', bodies: defaultBodies('Orion') },
    leir: { id: 'leir', name: 'Sistema Leir', sublabel: '2677', type: 'unclaimed', bodies: defaultBodies('Leir') },
    gliesse: { id: 'gliesse', name: 'Sistema Gliesse', sublabel: '2712', type: 'banu', bodies: defaultBodies('Gliesse') },
    tohil: {
        id: 'tohil',
        name: 'Sistema Tohil',
        sublabel: '2716',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Tohil I', color: '#708090' },
            { type: 'planet', name: 'Tohil II', color: '#5F9EA0' },
            { type: 'planet', name: 'Tohil III', color: '#8B7355' },
            { type: 'planet', name: 'Tohil IV', color: '#CD5C5C' },
            { type: 'planet', name: 'Tohil V', color: '#6B8E23' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    vanduul: { id: 'vanduul', name: 'Espacio Vanduul', sublabel: '2726', type: 'vanduul', bodies: defaultBodies('Vanduul') },
    trise: { id: 'trise', name: 'Sistema Trise', sublabel: '2745', type: 'banu', bodies: defaultBodies('Trise') },
    lauo: { id: 'lauo', name: 'Sistema La\'uo', sublabel: '2759', type: 'xian', bodies: defaultBodies('LaUo') },
    virtus: { id: 'virtus', name: 'Sistema Virtus', sublabel: '2759', type: 'xian', bodies: defaultBodies('Virtus') },
    garron: { id: 'garron', name: 'Sistema Garron', sublabel: '2784', type: 'uee', bodies: defaultBodies('Garron') },
    osiris: {
        id: 'osiris',
        name: 'Sistema Osiris',
        sublabel: '2788',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Osiris I', color: '#708090' },
            { type: 'planet', name: 'Osiris II', color: '#5F9EA0' },
            { type: 'planet', name: 'Etos', color: '#8B7355' },
            { type: 'planet', name: 'Or Kobold', color: '#CD5C5C' },
            { type: 'belt', name: 'Alpha Belt' }
        ]
    },
    tal: { id: 'tal', name: 'Sistema Tal', sublabel: '2789', type: 'uee', bodies: defaultBodies('Tal') },
    kellog: { id: 'kellog', name: 'Sistema Kellog', sublabel: '2811', type: 'uee', bodies: defaultBodies('Kellog') },
    genesis: {
        id: 'genesis',
        name: 'Sistema Genesis',
        sublabel: '2812',
        type: 'unclaimed',
        bodies: [
            { type: 'planet', name: 'Genesis I', color: '#708090' },
            { type: 'planet', name: 'Genesis II', color: '#5F9EA0' },
            { type: 'planet', name: 'Genesis III', color: '#8B7355' },
            { type: 'belt', name: 'Alpha Belt' }
        ]
    },
    tyrol: { id: 'tyrol', name: 'Sistema Tyrol', sublabel: '2823', type: 'uee', bodies: defaultBodies('Tyrol') },
    stanton: {
        id: 'stanton',
        name: 'Sistema Stanton',
        sublabel: '2851',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Hurston', color: '#8B7355' },
            { type: 'moon', name: 'Arial', color: '#A0826D' },
            { type: 'moon', name: 'Aberdeen', color: '#8B7355' },
            { type: 'moon', name: 'Magda', color: '#6B5344' },
            { type: 'moon', name: 'Ita', color: '#9B8B7D' },
            { type: 'planet', name: 'Crusader', color: '#87CEEB' },
            { type: 'moon', name: 'Cellin', color: '#7B9EB0' },
            { type: 'moon', name: 'Daymar', color: '#ADD8E6' },
            { type: 'moon', name: 'Yela', color: '#B0C4DE' },
            { type: 'planet', name: 'ArcCorp', color: '#20B2AA' },
            { type: 'moon', name: 'Lyria', color: '#2E8B57' },
            { type: 'moon', name: 'Wala', color: '#3CB371' },
            { type: 'planet', name: 'microTech', color: '#B0E0E6' },
            { type: 'moon', name: 'Calliope', color: '#7EC8C8' },
            { type: 'moon', name: 'Clio', color: '#AFEEEE' },
            { type: 'moon', name: 'Euterpe', color: '#98D8D8' },
            { type: 'belt', name: 'Aaron Halo' }
        ]
    },
    oso: {
        id: 'oso',
        name: 'Sistema Oso',
        sublabel: '2861',
        type: 'unclaimed',
        bodies: [
            { type: 'planet', name: 'Oso I', color: '#708090' },
            { type: 'planet', name: 'Oso II', color: '#5F9EA0' },
            { type: 'planet', name: 'Oso III', color: '#8B7355' },
            { type: 'planet', name: 'Oso IV', color: '#CD5C5C' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    chronos: { id: 'chronos', name: 'Sistema Chronos', sublabel: '2863', type: 'uee', bodies: defaultBodies('Chronos') },
    branaugh: { id: 'branaugh', name: 'Sistema Branaugh', sublabel: '2877', type: 'uee', bodies: defaultBodies('Branaugh') },
    viking: { id: 'viking', name: 'Sistema Viking', sublabel: '2884', type: 'uee', bodies: defaultBodies('Viking') },
    kallis: {
        id: 'kallis',
        name: 'Sistema Kallis',
        sublabel: '2921',
        type: 'unclaimed',
        bodies: [
            { type: 'planet', name: 'Kallis I', color: '#708090' },
            { type: 'planet', name: 'Kallis II', color: '#5F9EA0' },
            { type: 'planet', name: 'Kallis III', color: '#8B7355' },
            { type: 'planet', name: 'Kallis IV', color: '#CD5C5C' },
            { type: 'planet', name: 'Kallis V', color: '#6B8E23' },
            { type: 'planet', name: 'Kallis VI', color: '#2E8B57' },
            { type: 'planet', name: 'Kallis VII', color: '#87CEEB' },
            { type: 'planet', name: 'Kallis VIII', color: '#DDA0DD' },
            { type: 'planet', name: 'Kallis IX', color: '#DAA520' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    kabal: {
        id: 'kabal',
        name: 'Sistema Kabal',
        sublabel: '2941',
        type: 'uee',
        bodies: [
            { type: 'planet', name: 'Kabal I', color: '#708090' },
            { type: 'planet', name: 'Kabal II', color: '#5F9EA0' },
            { type: 'planet', name: 'Kabal III', color: '#8B7355' },
            { type: 'planet', name: 'Kabal IV', color: '#4169E1' },
            { type: 'planet', name: 'Alpha Cluster', color: '#CD5C5C' },
            { type: 'belt', name: 'Anillo' }
        ]
    },
    vanguard: { id: 'vanguard', name: 'Sistema Vanguard', sublabel: '2943', type: 'vanduul', bodies: defaultBodies('Vanguard') },
    tamsa: { id: 'tamsa', name: 'Sistema Tamsa', sublabel: '2943', type: 'uee', bodies: defaultBodies('Tamsa') },
    veritas: { id: 'veritas', name: 'Sistema Veritas', sublabel: '2945', type: 'vanduul', bodies: defaultBodies('Veritas') }
};
